import type { SVGProps } from 'react';

const ErrorHexagonIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.57479 0.411881C8.83852 0.148158 9.1962 0 9.56916 0H20.4308C20.8038 0 21.1615 0.148158 21.4252 0.411881L29.5881 8.57479C29.8518 8.83852 30 9.1962 30 9.56916V20.4308C30 20.8038 29.8518 21.1615 29.5881 21.4252L21.4252 29.5881C21.1615 29.8518 20.8038 30 20.4308 30H9.56916C9.1962 30 8.83852 29.8518 8.57479 29.5881L0.411881 21.4252C0.148158 21.1615 0 20.8038 0 20.4308V9.56916C0 9.1962 0.148158 8.83852 0.411881 8.57479L8.57479 0.411881ZM9.76332 1.875L1.875 9.76333V20.2367L9.76333 28.125H20.2367L28.125 20.2367V9.76333L20.2367 1.875H9.76332ZM7.77459 7.77459C8.1407 7.40847 8.7343 7.40847 9.10041 7.77459L22.2254 20.8996C22.5915 21.2657 22.5915 21.8593 22.2254 22.2254C21.8593 22.5915 21.2657 22.5915 20.8996 22.2254L7.77459 9.10041C7.40847 8.7343 7.40847 8.1407 7.77459 7.77459Z"
            fill="white"
        />
    </svg>
);

export default ErrorHexagonIcon;
